
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { MasterLayoutService } from './master-layout-service';

/**
 * 母版板式实例
 * 一个母版实例对应一个canvas节点
 */
export class MasterService extends MasterLayoutService {
    protected get elementType(): string {
        return UIModelType.MASTER;
    }
}
